const AD_CONFIG_PUBLICATIONS = ['wsj', 'jwsj', 'wsjopinion', 'buyside'];

/**
 * Validates Ad Placement Type and Ad Zone fields for publications that require them
 * Returns an error message if validation fails, or null if validation passes
 */
export const validateAdFields = (
  adPlacementType: string | null | undefined,
  adZone: string | null | undefined,
  publicationKey: string
): string | null => {
  // Only validate for publications that use Ad settings
  if (!AD_CONFIG_PUBLICATIONS.includes(publicationKey)) {
    return null;
  }

  // Check if Ad Placement Type is missing
  if (!adPlacementType) {
    return 'Ad Placement Type is required. Please select a placement type before publishing.';
  }

  // Check if Ad Zone is required but missing (when placement type is not "hidden")
  // Normalize to lowercase for comparison (handles both old uppercase and new lowercase values)
  if (adPlacementType.toLowerCase() !== 'hidden') {
    if (!adZone || adZone.trim() === '') {
      return 'Ad Zone is required when Ad Placement Type is set.';
    }
  }

  return null; // Validation passed
};
